module.exports = __webpack_public_path__ + "static/media/icon_template_set.98f075b2.svg";